module.exports = __webpack_public_path__ + "static/assets/83097fd0802e7f7ffb46788dc11e932c.png";